<script setup lang="ts">
import CardOptions from './CardOptions.vue'

const emit = defineEmits<{
  (e: 'edit-label', id: number | null): void
}>()

const props = defineProps({
  move: { type: Function, default: null },
  remove: { type: Function, default: null },
  push: { type: Function, default: null },
  clean: { type: Function, default: null },
  id: { type: Number, default: null },
  fieldLength: { type: Number, default: 0 },
  section: { type: String, default: '' },
})
</script>

<template>
  <CardOptions>
    <v-container
      class="menu pa-0"
      style="border-color: var(--v-theme-grey-lighten-2)"
      fluid
    >
      <!-- Editar rótulo -->
      <v-row
        :id="`edit-corporative-account-${props.section}-${props.id}-edit-label-button`"
        no-gutters
        class="menu-row"
        @click="emit('edit-label', props.id)"
      >
        <v-col cols="12" class="d-flex align-center">
          <span class="item-menu">
            {{ $t('corporate.edit.editLabelTitle') }}
          </span>
        </v-col>
      </v-row>

      <!-- Tornar principal -->
      <v-row
        no-gutters
        class="menu-row"
        :class="props.id === 0 ? 'pointer-events-none opacity-50' : ''"
        @click="props.id !== 0 && props.move && props.move(props.id, 0)"
      >
        <v-col cols="12" class="d-flex align-center">
          <span class="item-menu">
            {{ $t('corporate.edit.makeMain') }}
          </span>
        </v-col>
      </v-row>

      <!-- Remover -->
      <v-row
        no-gutters
        class="menu-row"
        @click="props.remove && props.remove(props.id)"
      >
        <v-col cols="12" class="d-flex align-center">
          <span class="item-menu-red">Excluir</span>
        </v-col>
      </v-row>
    </v-container>
  </CardOptions>
</template>

<style scoped>
.menu {
  /* tira o padding padrão do v-container e deixa só um respiro mínimo */
  padding: 4px 0 !important;
}

/* cada linha do menu com altura fixa ~32px */
.menu-row {
  min-height: 32px;
  cursor: pointer;
}

/* texto centralizado verticalmente dentro da linha */
.item-menu,
.item-menu-red {
  display: flex;
  align-items: center;
  /* sem altura extra, deixa a linha controlar a altura */
  height: 32px;
}

.item-menu {
  color: var(--opacity-text--secondary, rgba(0, 0, 0, 0.6));
  font-family: var(--Typography-fontFamilies-Open-Sans, 'Open Sans');
  font-size: var(--fontSize-77, 12px);
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.048px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.item-menu-red {
  color: var(--standart-theme---EVE-error, #ff5252);
  font-family: var(--Typography-fontFamilies-Open-Sans, 'Open Sans');
  font-size: var(--fontSize-77, 12px);
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.048px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>
